import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from 'utils/services';

import {
  CompleteMifReq,
  CompleteMifRes,
  GetMifAnswersReq,
  GetMifAnswersResProps,
  GetMifStructureRes,
  SendMifResponseReq,
  SendMifResponseRes,
  UpdateMifResponseReq
} from './mifs.types';

export const mifsApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    // Explicitly stamps `<program>.miCompletionStatus = true` for onboarding
    // flows whose MIF carries no completion-audience trigger (e.g. Men's
    // Health). Keyed on the submitted `medicalIntakeForm._id` (`resultId`),
    // mirroring the `updateMifResponse` route. Called once every step of the
    // flow is complete.
    completeMif: build.mutation<CompleteMifRes, CompleteMifReq>({
      query: ({ id, resultId }) => ({
        method: 'POST',
        url: `/mifs/${id}/results/${resultId}/complete`
      })
    }),
    getMifAnswers: build.query<GetMifAnswersResProps, GetMifAnswersReq>({
      query: (params) => ({
        ...(params && { params }),
        url: '/submitted-mifs'
      })
    }),
    getMifStructure: build.query<GetMifStructureRes, string>({
      query: (id) => ({
        url: `/mifs/${id}`
      })
    }),
    sendMifResponse: build.mutation<SendMifResponseRes, SendMifResponseReq>({
      query: ({ body, id }) => ({
        body,
        method: 'POST',
        url: `/mifs/${id}/results`
      })
    }),
    updateMifResponse: build.mutation<SendMifResponseRes, UpdateMifResponseReq>({
      query: ({ body, id, resultId }) => ({
        body,
        method: 'PATCH',
        url: `/mifs/${id}/results/${resultId}`
      })
    })
  }),
  reducerPath: 'mifsApi',
  tagTypes: ['mifs']
});

export const {
  useCompleteMifMutation,
  useGetMifAnswersQuery,
  useGetMifStructureQuery,
  useLazyGetMifAnswersQuery,
  useLazyGetMifStructureQuery,
  useSendMifResponseMutation,
  useUpdateMifResponseMutation
} = mifsApi;
